module.exports = __webpack_public_path__ + "static/whatSalaryDoTheyGet-03c16b9e4a3ce31fadca3dfe4b8061ae.png";